import axios, { isAxiosError } from 'axios';
import { Mutation, Query } from 'react-query';

import { QueryError } from '@/common/interfaces';

let isRefreshing = false;
let failedQueue: {
  query?: Query;
  mutation?: Mutation<unknown, unknown, unknown, unknown>;
  variables?: unknown;
}[] = [];

const processFailedQueue = () => {
  failedQueue.forEach(({ query, mutation, variables }) => {
    if (mutation) {
      const { options } = mutation;
      mutation.options = { ...options, variables };
      mutation.execute();
    }
    if (query) query.fetch();
  });
  isRefreshing = false;
  failedQueue = [];
};

const redirectToAuth = () => {
  window.location.href = `${ import.meta.env.VITE_AUTHENTICATOR_URL }?ref=` + encodeURIComponent(window.location.href);
};

const refreshTokenAndRetry = async (
  query?: Query,
  mutation?: Mutation<unknown, unknown, unknown, unknown>,
  variables?: unknown,
) => {
  if (isRefreshing) {
    failedQueue.push({ query, mutation, variables });
    return;
  }

  isRefreshing = true;
  failedQueue.push({ query, mutation, variables });
  let shouldProcess = true;
  try {
    await axios.post(`${ import.meta.env.VITE_AUTHENTICATOR_API_URL }/refresh`, {}, { withCredentials: true });
  } catch (err) {
    if (isAxiosError(err) && err.response?.status === 401) {
      redirectToAuth();
      shouldProcess = false;
    }
  }
  if (shouldProcess) processFailedQueue();
};

const errorHandler = (
  error: QueryError,
  query?: Query,
  mutation?: Mutation<unknown, unknown, unknown, unknown>,
  variables?: unknown,
) => {
  const status = error.response?.status;

  if (!status) return;

  if (status === 498) {
    if (mutation) refreshTokenAndRetry(undefined, mutation, variables);
    else refreshTokenAndRetry(query);
  }
  if (status === 401) {
    redirectToAuth();
  }
};

export const queryErrorHandler = (error: unknown, query: Query) => {
  errorHandler(error as QueryError, query);
};

export const mutationErrorHandler = (
  error: unknown,
  variables: unknown,
  context: unknown,
  mutation: Mutation<unknown, unknown, unknown, unknown>,
) => {
  errorHandler(error as QueryError, undefined, mutation, variables);
};
